import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { PlanGateService } from './plan-gate.service';

/**
 * Keeps a workspace whose allowance has run out on the billing route and
 * nowhere else. The backend already refuses the writes; this stops the user
 * from wandering through screens that can no longer do anything.
 */
@Injectable({ providedIn: 'root' })
export class PlanGuard implements CanActivate {

  constructor(private planGate: PlanGateService, private router: Router) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {

    // Billing, legal and auth stay reachable - otherwise there is no way to pay.
    if (this.planGate.isAllowedRoute(state.url)) {
      return true;
    }

    await this.planGate.ensureLoaded();

    if (!this.planGate.blocked) {
      return true;
    }

    return this.router.parseUrl('/subscription');
  }
}
